import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RouteAnimationsService {
  private shouldAnimate = true;
  constructor() {}

  public setShouldAnimate(shouldAnimate: boolean) {
    this.shouldAnimate = shouldAnimate;
  }

  public getShouldAnimate(): boolean {
    return this.shouldAnimate;
  }
}
